import React, { useState } from 'react';
import { hooks, Header } from '@engelvoelkersamericas/common-story-ui';
import { ContentFrame } from './components/ContentFrame';
import darkIcon from './assets/darkAcademy.svg';

const { GlobalProvider, ProfileProvider } = hooks;

function globalAssetUrl(path: string) {
  const globalAssetBase =
    (window as Window & { __GLOBAL_ASSET_BASE__?: string })
      .__GLOBAL_ASSET_BASE__ || '/global';

  return `${globalAssetBase}${path}`;
}

function App() {
  const [isSearching, setIsSearching] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [passedSearch, setPassedSearch] = useState<string | null>(null);
  function submitSearch() {
    setPassedSearch(searchValue);
  }

  function finishSearch() {
    setPassedSearch(null);
    setIsSearching(false);
    // setSearchValue('');
  }

  return (
    <GlobalProvider>
      <ProfileProvider>
        <Header
          isSearching={isSearching}
          setIsSearching={setIsSearching}
          searchValue={isSearching ? searchValue : undefined}
          setSearchValue={setSearchValue}
          onSearchSubmit={submitSearch}
          productName='Academy'
          productLogo={globalAssetUrl('/static/logos/academy.svg')}
          darkModeLogo={darkIcon}
          logoLink='/'
          showAppMenu={false}
          showSupport={false}
          cmsCourseId={-1}
        />

        <ContentFrame searchValue={passedSearch} finishSearch={finishSearch} />
      </ProfileProvider>
    </GlobalProvider>
  );
}

export default App;
